// extracted by mini-css-extract-plugin
module.exports = {"wrap":"s_wrap__3I4UH","icon":"s_icon__3Ppqe","rotate":"s_rotate__1LMfn"};